import { Pipe, PipeTransform } from '@angular/core'
import { DateFormatType, formatDate } from '../functions'

@Pipe({
  name: 'epoch',
  standalone: false,
})
export class EpochPipe implements PipeTransform {
  transform(value: any, format?: DateFormatType, defaultValue = $localize`Never`): string {
    return formatDate(value, format, false, defaultValue)
  }
}
